// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8327b2835d0f886cd564dbacf6ca07fc7e55961b/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};